// extracted by mini-css-extract-plugin
export default {"box":"GrayBox_box"};